import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { api_url } from '../../utils/utils'

export const rescategoryAdd = createAsyncThunk(
    'rescategory/rescategoryAdd',
    async ({ name, image }, { rejectWithValue, fulfillWithValue, getState }) => {
        const token = getState().auth.token
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        try {
            const formData = new FormData()
            formData.append('name', name)
            formData.append('image', image)
            const { data } = await axios.post(`${api_url}/api/rescategory-add`, formData, config)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const rescategoryEdit = createAsyncThunk(
    'rescategory/rescategoryEdit',
    async ({ id, name, image }, { rejectWithValue, fulfillWithValue, getState }) => {
        console.log(id)
        const token = getState().auth.token;
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        };

        try {
            const formData = new FormData();
            formData.append('id', id);
            formData.append('name', name);
            if (image) formData.append('image', image); // Only append image if it's provided

            const { data } = await axios.put(`${api_url}/api/rescategory-edit/${id}`, formData, config);

            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const rescategoryDelete = createAsyncThunk(
    'rescategory/rescategoryDelete',
    async (id, { rejectWithValue, fulfillWithValue, getState }) => {
        console.log(id)
      const token = getState().auth.token;
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      };
  
      try {
        const { data } = await axios.delete(`${api_url}/api/rescategory-delete/${id}`, config);
        return fulfillWithValue(data); // Return the response data on success
      } catch (error) {
        return rejectWithValue(error.response.data); // Return the error message on failure
      }
    }
  );
  
export const get_rescategory = createAsyncThunk(
    'rescategory/get_rescategory',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        const token = getState().auth.token
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        try {
            const { data } = await axios.get(`${api_url}/api/rescategory/get`, config)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)



export const rescategoryReducer = createSlice({
    name: 'rescategory',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        rescategorys: [],
        totalResCategory: 0
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: {
        [rescategoryAdd.pending]: (state, _) => {
            state.loader = true
        },
        [rescategoryAdd.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [rescategoryAdd.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            state.rescategorys = [...state.rescategorys, payload.rescategory]
        },
        [rescategoryEdit.pending]: (state, _) => {
            state.loader = true
        },
        [rescategoryEdit.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [rescategoryEdit.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [rescategoryDelete.pending]: (state, _) => {
            state.loader = true
        },
        [rescategoryDelete.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [rescategoryDelete.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [get_rescategory.fulfilled]: (state, { payload }) => {
            state.rescategorys = payload
        },
    }

})
export const { messageClear } = rescategoryReducer.actions
export default rescategoryReducer.reducer